const defaultURL = process.env.NODE_ENV === 'production'
    ? 'https://altosandes.grupoeuromotors.online:449/'
    : 'http://127.0.0.1:8000/';

const URL = process.env.VUE_APP_API_URL || defaultURL;
export default URL;
